import store from "../store";
import { setChartData } from "../store/devdocs/actions";

export const getChartData = async (dateTime: Date, facilityName: string) => {
    facilityName = facilityName.trim();
    const response = await fetch(`/.netlify/functions/get-chart-data`, {
        method: 'POST',
        body: JSON.stringify({dateTime, facilityName})
    })
    const data = await response.json();
    store.dispatch(setChartData(data));
}